import React, { Component, Fragment } from 'react'
import axios from 'axios'
import swal from 'sweetalert'
import { Row, Col, FormGroup, FormControl, ControlLabel, Button } from 'react-bootstrap'

import getServerURL from '../../../functions/getServerURL'
import { handleErrorFetchingData } from '../../../functions/errorHandling'

// PROPS
// options: array of objects
// method: string, 'PATCH' or 'POST'
// route: string, route to backend (ex: 'roles')
// formFields: array of fields as strings (ex: ['name', 'subgroup'])
// displayNameSingular: string (ex: 'Role')
// displayNamePlural: string (ex: 'Roles')
// labelKey: function, used to create labels for option objects (ex: (option) => `${option.name} - ${option.subgroup}`)
// handleSaveSuccess: function, used to handle data returned from this.handleSave 

class AddOrEditSimpleInstance extends Component {
	constructor(props) {
    super(props)
    const stateFields = {}
    
    props.formFields.forEach(field => {
      stateFields[field] = ""
    })
    this.state = {
      selectedOption: null,
      ...stateFields,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if ((!prevProps.formFields && this.props.formFields) || 
    (prevProps.formFields.length !== this.props.formFields.length)) {
      const stateFields = {}
      this.props.formFields.forEach(field => {
        stateFields[field] = ""
      })
      return this.setState(stateFields)
    }
  }


  handleChange = (e) => this.setState({ [e.target.name]: e.target.value })

  handleSelect = (event) => {
    const { options, formFields } = this.props
    const url = event.target.value
    const updatedState = {}
    if (url === '') {
      updatedState.selectedOption = null
      formFields.forEach(field => updatedState[field] = '')
    } else {
      const selectedOption = options.find(option => option.url === url)
      updatedState.selectedOption = selectedOption
      formFields.forEach(field => updatedState[field] = selectedOption[field])
    }
    return this.setState(updatedState)
  }

	handleSave = () => {
		swal({
			text: "Saving...",
			icon: require("../../../static/images/spinner.gif"),
			button: false
		})

    let url
    if (this.props.method.toUpperCase() === 'PATCH' && !this.state.selectedOption) {
      return
    } else if (this.props.method.toUpperCase() === 'PATCH') {
      url = this.state.selectedOption.url
    } else {
      url = `${getServerURL()}${this.props.route}/`
    }

    const data = {}
    this.props.formFields.forEach(field => {
      data[field] = this.state[field]
    })

		axios({
      method: this.props.method.toUpperCase(),
			headers: { "Authorization": "Bearer " + localStorage.getItem("token") },
      url,
			data,
		})
    .then(response => {
      swal({
        title: "Success",
        text: `The ${this.props.displayNameSingular.toLowerCase()} has been saved`,
        icon: "success",
        button: "Continue",
      })
      this.props.handleSaveSuccess(response.data)
    })
    .catch(error => {
      const message = `There was an error saving the ${this.props.displayNameSingular.toLowerCase()}`
      handleErrorFetchingData(error, message)
    })
	}

	render() {
    let sortedOptions = []
    if (Array.isArray(this.props.options) && this.props.labelKey) {
      sortedOptions = this.props.options.sort((a, b) => {
        const optionLabelKeyA = this.props.labelKey(a)
        const optionLabelKeyB = this.props.labelKey(b)
        return optionLabelKeyA.localeCompare(optionLabelKeyB)
      })
    }
		return (
			<div>
				<FormGroup>
          {this.props.method.toUpperCase() === 'PATCH' && this.props.options ?
            <Fragment>
              <ControlLabel>
                Select a {this.props.displayNameSingular.toLowerCase()} to edit
            </ControlLabel>
              <FormControl
                componentClass="select"
                name="selectedOption"
                onChange={this.handleSelect}
                selected={this.state.selectedOption}
              >
                <option value=''>
                  -
              </option>
                {sortedOptions.map(option => {
                  return (
                    <option key={option.url} value={option.url}>
                      {this.props.labelKey(option)}
                    </option>
                  )
                })}
              </FormControl>
              <br />
            </Fragment>
            :
            null
          }

          {this.props.method.toUpperCase() === 'PATCH' && !this.state.selectedOption ?
            null
            :
            <Fragment>
              {this.props.formFields.map(field => {
                return (
                  <Fragment key={field + '-form'}>
                    <ControlLabel>
                      {field.split('_').map(word => word[0].toUpperCase() + word.slice(1)).join(' ')}
                    </ControlLabel>
                    <FormControl
                      type="text"
                      value={this.state[field]}
                      placeholder={`Enter ${field.split('_').join(' ').toLowerCase()}...`}
                      name={field}
                      onChange={this.handleChange}
                    />
                    <br />
                  </Fragment>
                )
              })}
            </Fragment>
          }
          <Button
            bsStyle="primary"
            onClick={this.handleSave}
          >
            Save
          </Button>
        </FormGroup>

        {this.props.method.toUpperCase() === 'POST' ?
          <Row>
            <Col xs={12}>
              {this.props.options.length > 0 ?
                <span>
                  List of {this.props.displayNamePlural.toLowerCase()} that already exist
                  <ul>
                    {sortedOptions.map(option => {
                      return (
                        <Col md={6} key={option.id}>
                          <li>
                            {this.props.labelKey(option)}
                          </li>
                        </Col>
                      )
                    })}
                  </ul>
                </span>
                :
                <span>
                  No {this.props.displayNamePlural.toLowerCase()} metadata types exist in the database
              </span>
              }
            </Col>
          </Row>
          :
          null  
        }

			</div>
		)
	}
}

export default AddOrEditSimpleInstance



// WEBPACK FOOTER //
// ./src/routes/manager/components/AddOrEditSimpleInstance.js